module.exports = __webpack_public_path__ + "static/media/gear-icon.e650311c.svg";